import React from 'react';

import IMG_1 from '../../../Images/gallery/interceramic/img_1.png';
import IMG_2 from '../../../Images/gallery/interceramic/img_2.png';
import IMG_3 from '../../../Images/gallery/interceramic/img_3.png';

export const Interceramic_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>INTERCERAMIC</span>,
  },
];

export const Title_1 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>libera tu inspiración: cocina</span>,
  },
];

export const Title_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOTO FIJA</span>,
  },
];

export const Interceramic_Gallery = [
  {
    src: IMG_1,
    imgWidth: '100%',
  },
  {
    src: IMG_2,
    imgWidth: '50%',
  },
  {
    src: IMG_3,
    imgWidth: '50%',
  },
];
